// Cache-busting version: V200_NGINX_DIRECT - Updated 2026-01-11T21:33:43.332025
/**
 * PRODUCTION FIX: Runtime Domain Detection
 * This ensures assets ALWAYS use the current domain, regardless of build-time env vars
 */

/**
 * Get the correct backend URL based on current runtime domain
 * This runs in the browser and detects the actual domain
 */
export const getBackendURL = () => {
  // Runtime detection (browser only)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;

    // Production domains for CISH
    if (hostname === 'www.cish.org.in' || hostname === 'cish.org.in') {
      return `${protocol}//${hostname}`;
    }

    // Emergent preview domains - use current domain
    if (hostname.includes('emergent.host') || hostname.includes('emergentagent.com')) {
      return `${protocol}//${hostname}`;
    }

    // Local development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_BACKEND_URL || `${protocol}//${hostname}:8001`;
    }

    // IP address or other domains - use current origin (implies API is proxied)
    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  }

  // Server-side fallback
  return process.env.REACT_APP_BACKEND_URL || '';
};

/**
 * Construct proper file URLs for assets
 * ALWAYS uses runtime-detected domain
 */
export const getFileUrl = (fileUrl) => {


  if (!fileUrl) {

    return null;
  }

  // Robustness check: if it's an array, try to use the first item
  if (Array.isArray(fileUrl)) {
    if (fileUrl.length > 0 && typeof fileUrl[0] === 'string') {
      return getFileUrl(fileUrl[0]);
    }
    return null;
  }

  // Ensure fileUrl is a string before proceeding
  if (typeof fileUrl !== 'string') {

    return null;
  }

  // If it's a data URI (base64), return as is
  if (fileUrl.startsWith('data:')) {

    return fileUrl;
  }

  const backendURL = getBackendURL();


  // If already a full URL pointing to emergent domains, convert to current domain
  if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
    // If it's pointing to emergent preview domain and we're on cish.org.in, fix it
    if (typeof window !== 'undefined' &&
      (window.location.hostname === 'www.cish.org.in' || window.location.hostname === 'cish.org.in')) {
      if (fileUrl.includes('emergent.host') || fileUrl.includes('emergentagent.com') ||
        fileUrl.includes('publication-admin')) {
        // Extract the path part (/api/uploads/...)
        const pathMatch = fileUrl.match(/\/(api\/uploads\/.+)$/);
        if (pathMatch) {
          const result = `${backendURL}/${pathMatch[1]}`;

          return result;
        }
      }
    }
    // Return full URL as-is (external resources)

    return fileUrl;
  }

  // Convert data/files/ format to /api/uploads/
  if (fileUrl.startsWith('data/files/')) {
    const filename = fileUrl.replace('data/files/', '');
    const result = `${backendURL}/api/uploads/${filename}`;

    return result;
  }

  // If already starts with /api/uploads, use current domain
  if (fileUrl.startsWith('/api/uploads')) {
    const result = `${backendURL}${fileUrl}`;

    return result;
  }

  // Legacy /uploads path - served directly by Nginx from root
  // /uploads paths are served directly by Nginx, don't add backend URL
  if (fileUrl.startsWith('/uploads')) {

    return fileUrl;
  }

  // Gracefully handle legacy /api/uploads/ (redirect to Nginx /uploads/)
  if (fileUrl.startsWith('/api/uploads/')) {
    const fixedUrl = fileUrl.replace('/api/uploads/', '/uploads/');

    return fixedUrl;
  }

  // If starts with /, use as is
  if (fileUrl.startsWith('/')) {
    const result = `${backendURL}${fileUrl}`;

    return result;
  }

  // Otherwise assume it's a filename that needs /api/uploads prefix
  const result = `${backendURL}/api/uploads/${fileUrl}`;

  return result;
};

/**
 * Get image URL (alias for getFileUrl)
 */
export const getImageUrl = (imageUrl) => {
  return getFileUrl(imageUrl);
};

// Log current configuration (debugging)
if (typeof window !== 'undefined') {


}

export default {
  getBackendURL,
  getFileUrl,
  getImageUrl
};
